import { render, staticRenderFns } from "./commodityCounts.vue?vue&type=template&id=5f946e92&scoped=true&"
import script from "./commodityCounts.vue?vue&type=script&lang=js&"
export * from "./commodityCounts.vue?vue&type=script&lang=js&"
import style0 from "./commodityCounts.vue?vue&type=style&index=0&id=5f946e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f946e92",
  null
  
)

export default component.exports